import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft'

import { Link } from 'react-router-dom'

const locations = {
    page: '/pages',
    article: '/articles',
    blog: '/articles',
    template: '/templates',
    element: '/elements',
}

const BackButton = ({ contentType = 'page' }) => {
    return (
        <Link className="back" to={locations[contentType]} data-testid="navigate-back">
            <FontAwesomeIcon icon={faChevronLeft} />
        </Link>
    )
}

export default BackButton
